import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../../src/assets/images/login-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "logoInLogin"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  "data-cy": "submit",
  class: "submit-button"
}, " Войти ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.doLogin()), ["prevent"])),
    class: "login-form"
  }, [
    _hoisted_1,
    _createVNode("label", null, [
      _withDirectives(_createVNode("input", {
        type: "text",
        "data-cy": "login",
        placeholder: "Логин",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.login = $event))
      }, null, 512), [
        [_vModelText, _ctx.login]
      ])
    ]),
    _createVNode("label", null, [
      _withDirectives(_createVNode("input", {
        type: "password",
        "data-cy": "password",
        placeholder: "Пароль",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.password = $event))
      }, null, 512), [
        [_vModelText, _ctx.password]
      ])
    ]),
    _hoisted_2
  ], 32))
}